import React from 'react';
import cx from 'classnames';
import Switch from '@material-ui/core/Switch';
import { withStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

const BG_COLOR_DEFAULT = '#9FA8BD';
const TRACK_WIDTH = 36;
const TRACK_HEIGHT = 20;
const PADDING = 2;
const THUMB_SIZE = TRACK_HEIGHT - PADDING * 2;

const NARROW_TRACK_WIDTH = 32;

const getThumbTranslateValue = (width) => (width - PADDING * 2) / 2;

export const CustomSwitch = withStyles(
  (theme) => ({
    root: {
      width: TRACK_WIDTH,
      height: TRACK_HEIGHT,
      padding: 0,

      '&$narrow': {
        width: NARROW_TRACK_WIDTH,
      },
    },

    switchBase: {
      padding: PADDING,

      '&$checked': {
        transform: `translateX(${getThumbTranslateValue(TRACK_WIDTH)}px)`,
        color: theme.palette.common.white,

        '& + $track': {
          backgroundColor: theme.palette.grey[600],
          borderColor: theme.palette.grey[600],
          opacity: 1,
        },

        '$narrow &': {
          transform: `translateX(${getThumbTranslateValue(NARROW_TRACK_WIDTH)}px)`,
        },
      },

      '&$focusVisible $thumb': {
        color: theme.palette.grey[600],
        border: '4px solid #fff',
      },
    },

    thumb: {
      width: THUMB_SIZE,
      height: THUMB_SIZE,

      '$narrow &': {
        border: `1px solid ${COLORS.gray.gray60}`,
        boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.1), 0px 1px 2px -1px rgba(0, 0, 0, 0.1)',
      },
    },

    track: {
      borderRadius: TRACK_HEIGHT / 2,
      border: `2px solid ${BG_COLOR_DEFAULT}`,
      backgroundColor: BG_COLOR_DEFAULT,
      opacity: 0.5,
      transition: theme.transitions.create(['background-color', 'border']),

      '$narrow &': {
        height: 'auto',
        margin: '5px 2px',
      },
    },
    checked: {},
    focusVisible: {},
    disabled: {},

    colorPrimary: {
      '&$switchBase': {
        '&$checked': {
          '& + $track': {
            backgroundColor: theme.palette.primary.main,
            borderColor: theme.palette.primary.main,
          },
        },

        '&$focusVisible $thumb': {
          color: theme.palette.primary.main,
        },
      },
    },

    colorSecondary: {
      '&$switchBase': {
        '&$checked': {
          '& + $track': {
            backgroundColor: theme.palette.secondary.main,
            borderColor: theme.palette.secondary.main,
          },
        },

        '&$focusVisible $thumb': {
          color: theme.palette.secondary.main,
        },
      },
    },

    narrow: {},
  }),
  { name: 'CustomSwitch' }
)(({ className, classes, narrow, ...props }) => (
  <Switch
    className={cx(className, { [classes.narrow]: narrow })}
    classes={{
      root: classes.root,
      switchBase: classes.switchBase,
      thumb: classes.thumb,
      track: classes.track,
      checked: classes.checked,
      colorPrimary: classes.colorPrimary,
      colorSecondary: classes.colorSecondary,
      disabled: classes.disabled,
    }}
    focusVisibleClassName={classes.focusVisible}
    {...props}
  />
));
